import { IPackageProgramItem, IPackageProgramTier } from 'services/shop/types/package-program';
import uuid from 'utils/uuid';
import { DiscountType } from './constants';
import { IService, IStaffItem } from './types/api';
import { SERVICE_ITEM_TYPE } from './types/constant';

/** tier được chọn trên panel Packages, kèm program để đặt tên item trong ticket */
export type IPackageTierTicketDraft = {
  program: IPackageProgramItem;
  tier: IPackageProgramTier;
};

// Item PACKAGE trong ticket; itemId là tier.id để BE biết đúng tier (số buổi, giá) đã mua
export const buildPackageTicketService = ({ program, tier }: IPackageTierTicketDraft): IService => ({
  itemId: tier.id,
  itemName: `${program.name} - ${tier.name}`,
  itemType: SERVICE_ITEM_TYPE.PACKAGE,
  price: tier.packagePrice || 0,
  discount: 0,
  note: null,
  duration: 0,
  discountType: DiscountType.MONEY,
  uuid_local: uuid(),
});

// Số buổi cho dòng "{quantity} Sessions" trong ticket, tra từ program list đã load.
// Trả null khi list chưa có tier này (tier bị xoá / list chưa load) để UI ẩn dòng.
export const getPackageTierSessions = (programs: IPackageProgramItem[] | undefined, tierId: string): number | null => {
  for (const program of programs || []) {
    const tier = (program.tiers || []).find((o) => o.id === tierId);
    if (tier) return tier.quantity;
  }
  return null;
};

/** Tier đã nằm trên ticket chưa — mỗi tier chỉ được bán 1 lần trên một ticket */
export const isPackageTierOnTicket = (selectedItems: IStaffItem[], tierId: string): boolean =>
  (selectedItems || []).some((staff) =>
    (staff.services || []).some((service) => service.itemType === SERVICE_ITEM_TYPE.PACKAGE && service.itemId === tierId),
  );
